import { Logger } from '@tencent/logger';

// 全局实例，业务模块也可初始化自己的日志实例，指定不同的模块名前缀
const logger = new Logger('rmonitor').use('console');

export { logger };
